import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import IdleDetect from './IdleDetect'

import { setIsIdle } from 'src/modules/App/actions'
import { resetChat } from 'src/modules/Chat/actions'

const mapDispatchToProps = {
  setIsIdle,
  resetChat,
}

const mapStateToProps = state => {
  return {
    user: state.user.user,
    isIdle: state.appReducer.isIdle,
    isChatEmpty: state.chat.isChatEmpty,
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IdleDetect))
